import _core from "./core.js";
import _visible from "./components/visible.js";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hydrateLazy = void 0;
const core_js_1 = _core;
const visible_js_1 = _visible;

const hydrateLazy = (component, parent = null, removeChildNodes = true) => {
  const c = (0, core_js_1.h)(visible_js_1.Visible, null, component);
  return (0, core_js_1.hydrate)(c, parent, removeChildNodes);
};

exports.hydrateLazy = hydrateLazy; //# sourceMappingURL=lazy.js.map

export default exports;